// extracted by mini-css-extract-plugin
module.exports = {"verifyCodeInputWrapper":"styles_verifyCodeInputWrapper__q3KK2","verifyCodeInput":"styles_verifyCodeInput__3AvOM","splitLine":"styles_splitLine__1qaEv"};